module.exports = __webpack_public_path__ + "media/images/lb/330-32be16f0d22735a93b1800e707a90255.svg";